// ============================================================================
// servicesAPI — cliente dos endpoints /api/services-*
// ============================================================================
// Substitui o ciclo localStorage → cloud sync de fk_services.json. Agora cada
// operação vai DIRETO no Postgres via API → sem race condition de array.
// ============================================================================

function getAuthHeaders() {
  try {
    const raw = sessionStorage.getItem('fk_session');
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    const token = parsed?.sessionToken;
    return token ? { 'x-session-token': token } : {};
  } catch {
    return {};
  }
}

export async function fetchServices() {
  const r = await fetch('/api/services-list', {
    cache: 'no-store',
    headers: { 'Cache-Control': 'no-store' },
  });
  if (!r.ok) throw new Error(`Falha ao listar serviços (${r.status})`);
  const json = await r.json();
  return json.services || [];
}

export async function upsertService(service) {
  const r = await fetch('/api/services-upsert', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify(service),
  });
  if (!r.ok) {
    const err = await r.json().catch(() => ({}));
    throw new Error(err.error || `Falha ao salvar serviço (${r.status})`);
  }
  const json = await r.json();
  return json.service;
}

export async function deleteService(id) {
  const r = await fetch(`/api/services-delete?id=${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  if (!r.ok) {
    const err = await r.json().catch(() => ({}));
    throw new Error(err.error || `Falha ao deletar serviço (${r.status})`);
  }
  return true;
}
